import React, { CSSProperties, FunctionComponent, MouseEvent } from 'react';
import type { ComponentProps } from './types';

type Props = ComponentProps & {
  isPc: boolean;
  isPush: boolean;
  btnStyle: CSSProperties;
  handleClickCreateBookmark: (event: MouseEvent<HTMLAnchorElement>) => void;
  handleClickDeleteBookmark: (event: MouseEvent<HTMLAnchorElement>) => void;
  bookmarkOnRecruitmentPanelCategory: () => string;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  // 一覧カードから渡されたときだけ data-list-type を出力する（プレビュー時は計測しないので付けない）
  const listTypeAttr =
    !props.isPreview && props.dataListType ? { 'data-list-type': props.dataListType } : {};

  return (
    <div className={`button-bookmark ${!props.isShow && 'is-active'} ${props.isStopped && 'is-hide'}`}>
      {props.isSpecial &&
        <div className="button-bookmark-inner">
          <div className="article-card-favorite">
            <a href={`/recruitments/${props.recruitmentId}`} className="article-card-favorite--detail gtm-recruitment-view-count" {...(!props.isPreview && {'data-event-name': 'recruitments on screen','data-event': 'click', 'data-category': props.dataCategory, 'data-value': 'to_recruitment_contents'})}>求人詳細</a>
            <a href="javascript:void(0);" {...(!props.isPreview && {'data-event-name': 'favorite on screen','data-event': 'click', 'data-category': props.dataCategory, 'data-value': !props.isPush ? 'favorite' : 'cancel_favorite'})} {...listTypeAttr} className={`article-card-favorite--bookmark ${props.isPush && 'is-saved'} favorite_popup gtm-favorite-view-count`} style={props.btnStyle} onClick={!props.isPush ? props.handleClickCreateBookmark : props.handleClickDeleteBookmark}>
              {props.isPush ? '保存済み' : '求人を保存'}
            </a>
          </div>
        </div>
      }

      {!props.isSpecial && props.isShow && (
        <div className="button-bookmark-inner">
          {props.isPc ? (
            <a
              href="javascript:void(0);"
              {...(!props.isPreview && {'data-event-name': 'favorite on screen','data-event': 'click', 'data-category': props.dataCategory, 'data-value': !props.isPush ? 'favorite' : 'cancel_favorite'})}
              {...listTypeAttr}
              className={`button-bookmark-pc ${props.isPush && 'is-saved'} favorite_popup gtm-favorite-view-count`}
              style={props.btnStyle}
              onClick={!props.isPush ? props.handleClickCreateBookmark : props.handleClickDeleteBookmark}
            >
              {props.isPush ? '保存済み' : '求人を保存'}
            </a>
          ) : (
            <a
              href="javascript:void(0);"
              {...(!props.isPreview && {'data-event-name': 'favorite on screen','data-event': 'click', 'data-category': props.railsDataCategory, 'data-value': !props.isPush ? 'favorite' : 'cancel_favorite'})}
              {...listTypeAttr}
              className={`button-bookmark-icon ${props.isShow && 'is-show'} favorite_popup gtm-favorite-view-count`}
              onClick={!props.isPush ? props.handleClickCreateBookmark : props.handleClickDeleteBookmark}
            >
              {props.isPush ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                  <path
                    d="M0.258057 20V2.08435C0.258057 1.49048 0.456981 0.994624 0.854831 0.596774C1.25268 0.198925 1.74854 0 2.34241 0H13.6576C14.2514 0 14.7473 0.198925 15.1452 0.596774C15.543 0.994624 15.7419 1.49048 15.7419 2.08435V20L7.99999 16.6749L0.258057 20Z"
                    fill="#FFFF00"
                  />
                  <path
                    d="M0.258057 20V2.08435C0.258057 1.49048 0.456981 0.994624 0.854831 0.596774C1.25268 0.198925 1.74854 0 2.34241 0H13.6576C14.2514 0 14.7473 0.198925 15.1452 0.596774C15.543 0.994624 15.7419 1.49048 15.7419 2.08435V20L7.99999 16.6749L0.258057 20ZM1.54838 18L7.99999 15.2258L14.4516 18V2.08435C14.4516 1.88586 14.3689 1.70389 14.2035 1.53845C14.038 1.37303 13.8561 1.29032 13.6576 1.29032H2.34241C2.14392 1.29032 1.96195 1.37303 1.79651 1.53845C1.63109 1.70389 1.54838 1.88586 1.54838 2.08435V18Z"
                    fill="#FFFF00"
                  />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                  <path
                    d="M0.258057 20V2.08435C0.258057 1.49048 0.456981 0.994624 0.854831 0.596774C1.25268 0.198925 1.74854 0 2.34241 0H13.6576C14.2514 0 14.7473 0.198925 15.1452 0.596774C15.543 0.994624 15.7419 1.49048 15.7419 2.08435V20L7.99999 16.6749L0.258057 20ZM1.54838 18L7.99999 15.2258L14.4516 18V2.08435C14.4516 1.88586 14.3689 1.70389 14.2035 1.53845C14.038 1.37303 13.8561 1.29032 13.6576 1.29032H2.34241C2.14392 1.29032 1.96195 1.37303 1.79651 1.53845C1.63109 1.70389 1.54838 1.88586 1.54838 2.08435V18Z"
                    fill="#FFFFFF"
                  />
                </svg>
              )}
            </a>
          )}
        </div>
      )}
      {!props.isSpecial && !props.isShow && (
        <div className="button-bookmark-inner">
          <a
            {...(!props.isPreview && {'data-event-name': 'favorite on screen','data-event': 'click', 'data-category': props.bookmarkOnRecruitmentPanelCategory(), 'data-value': !props.isPush ? 'favorite' : 'cancel_favorite'})}
            {...listTypeAttr}
            className="button-bookmark-icon favorite_popup gtm-favorite-view-count"
            onClick={!props.isPush ? props.handleClickCreateBookmark : props.handleClickDeleteBookmark}
          >
            {props.isPush ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="36" viewBox="0 0 32 36" fill="none">
                <g filter="url(#filter0_d_1_1072)">
                  <path
                    d="M8.25806 26V8.08435C8.25806 7.49048 8.45698 6.99462 8.85483 6.59677C9.25268 6.19892 9.74854 6 10.3424 6H21.6576C22.2514 6 22.7473 6.19892 23.1452 6.59677C23.543 6.99462 23.7419 7.49048 23.7419 8.08435V26L16 22.6749L8.25806 26Z"
                    fill="#FFFF00"
                  />
                  <path
                    d="M8.25806 26V8.08435C8.25806 7.49048 8.45698 6.99462 8.85483 6.59677C9.25268 6.19892 9.74854 6 10.3424 6H21.6576C22.2514 6 22.7473 6.19892 23.1452 6.59677C23.543 6.99462 23.7419 7.49048 23.7419 8.08435V26L16 22.6749L8.25806 26ZM9.54838 24L16 21.2258L22.4516 24V8.08435C22.4516 7.88586 22.3689 7.70389 22.2035 7.53845C22.038 7.37303 21.8561 7.29032 21.6576 7.29032H10.3424C10.1439 7.29032 9.96195 7.37303 9.79651 7.53845C9.63109 7.70389 9.54838 7.88586 9.54838 8.08435V24Z"
                    fill="#FFFF00"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_1_1072"
                    x="0.258057"
                    y="0"
                    width="31.4839"
                    height="36"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="4" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_1072" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_1072" result="shape" />
                  </filter>
                </defs>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="36" viewBox="0 0 32 36" fill="none">
                <g filter="url(#filter0_d_1_1068)">
                  <path
                    d="M8.25806 26V8.08435C8.25806 7.49048 8.45698 6.99462 8.85483 6.59677C9.25268 6.19892 9.74854 6 10.3424 6H21.6576C22.2514 6 22.7473 6.19892 23.1452 6.59677C23.543 6.99462 23.7419 7.49048 23.7419 8.08435V26L16 22.6749L8.25806 26Z"
                    fill="#19190F"
                    fillOpacity="0.5"
                  />
                  <path
                    d="M8.25806 26V8.08435C8.25806 7.49048 8.45698 6.99462 8.85483 6.59677C9.25268 6.19892 9.74854 6 10.3424 6H21.6576C22.2514 6 22.7473 6.19892 23.1452 6.59677C23.543 6.99462 23.7419 7.49048 23.7419 8.08435V26L16 22.6749L8.25806 26ZM9.54838 24L16 21.2258L22.4516 24V8.08435C22.4516 7.88586 22.3689 7.70389 22.2035 7.53845C22.038 7.37303 21.8561 7.29032 21.6576 7.29032H10.3424C10.1439 7.29032 9.96195 7.37303 9.79651 7.53845C9.63109 7.70389 9.54838 7.88586 9.54838 8.08435V24Z"
                    fill="#FFFFFF"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_1_1068"
                    x="0.258057"
                    y="0"
                    width="31.4839"
                    height="36"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="4" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_1068" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_1068" result="shape" />
                  </filter>
                </defs>
              </svg>
            )}
          </a>
        </div>
      )}
    </div>
  );
};
